module.exports = __webpack_public_path__ + "public/images/scribble-sketch-texture-bg-translucent.fb7ec4db7372c7ff9fd7861a033810b3.png";